import React, {useEffect, useState} from 'react';
import {useLocation} from 'react-router-dom';
// Components
import Preloader from "./PreLoader";
import Header from "./Header";
import Background from "./Background";
import LandingSection from "./LandingSection";
import OurService from "./OurService";
import OurProject from "./OurProject";
import AboutUs from "./AboutUs";
import ContactForm from "./ContactForm";
import Footer from "./Footer";
import MoveToTopButton from "./MoveToTopButton";
// CSS
import '../../styles/tailwind-theme-one.css';
import '../../styles/custom-theme-one.css';
import ThemeTwoTransition from '../theme-two/custom-components/ThemeTwoTransition';

const ThemeOne = ({setVisibleRipple}: Props) => {
    const location = useLocation();
    const [animationCss, setAnimationCss] = useState(
        () => location.hash ? "top-[-100vh]" : "",
    );
    const [themeTwoTransition, setThemeTwoTransition] = useState(false);

    /**
     * Preloader hiding watch
     * */
    useEffect(() => {
        // A section link already communicates the user's destination. Avoid
        // making them wait behind the landing-page preloader before scrolling.
        if (location.hash) {
            setAnimationCss("top-[-100vh]");
            return;
        }

        const timer = window.setTimeout(() => {
            setAnimationCss("top-[-100vh]");
        }, 1000);

        return () => window.clearTimeout(timer);
    }, [location.hash]);

    useEffect(() => {
        const sectionId = decodeURIComponent(location.hash.replace(/^#/, ""));
        if (!sectionId) return;

        const scrollToSection = (behavior: ScrollBehavior) => {
            document.getElementById(sectionId)?.scrollIntoView({
                behavior,
                block: "start",
            });
        };

        // React mounts the landing page after the route changes, so the browser's
        // native hash jump can run before the destination exists. Scroll once after
        // the mount and once after the preloader/layout settles.
        const animationFrame = window.requestAnimationFrame(() => scrollToSection("auto"));
        const correctionTimer = window.setTimeout(
            () => scrollToSection("auto"),
            1100,
        );

        return () => {
            window.cancelAnimationFrame(animationFrame);
            window.clearTimeout(correctionTimer);
        };
    }, [location.hash]);

    return (
        <div className="qouda-home">
            <div>
                <Preloader animationClass={animationCss}/>
                <ThemeTwoTransition transition={themeTwoTransition }/>
                <Header/>
                <Background/>
                {/* Landing page section */}
                <LandingSection setThemeTwo={setThemeTwoTransition}/>
                {/* Our services */}
                <OurService/>
                {/* Our projects */}
                <OurProject/>
                {/* About us */}
                <AboutUs/>
                {/* Contact form */}
                <ContactForm/>
                {/* Footer */}
                <Footer/>
                {/* Move to top button */}
                <MoveToTopButton/>
            </div>
        </div>
    );
};

interface Props {
    setVisibleRipple: any;
}

export default ThemeOne;
